import React, { useEffect, useState } from "react";
import apiClient from "../../lib/api";
import { useI18n } from "../../i18n";
import { toast } from "sonner";
import { Plus, Trash2, Save } from "lucide-react";

const blank = { slug: "", name_en: "", name_nl: "", order: 99 };

const AdminCategories = () => {
  const { lang } = useI18n();
  const [items, setItems] = useState([]);
  const [newCat, setNewCat] = useState(blank);

  const load = () => apiClient.get("/categories").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!newCat.slug || !newCat.name_en) return;
    try {
      await apiClient.post("/admin/categories", newCat);
      setNewCat(blank);
      load();
      toast.success(lang === "nl" ? "Aangemaakt" : "Created");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    }
  };

  const save = async (cat) => {
    try {
      await apiClient.put(`/admin/categories/${cat.slug}`, cat);
      toast.success(lang === "nl" ? "Opgeslagen" : "Saved");
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };

  const remove = async (slug) => {
    if (!window.confirm(lang === "nl" ? "Verwijderen?" : "Delete?")) return;
    try {
      await apiClient.delete(`/admin/categories/${slug}`);
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };

  const update = (idx, key, val) => {
    const copy = [...items];
    copy[idx] = { ...copy[idx], [key]: val };
    setItems(copy);
  };

  return (
    <div data-testid="admin-categories-page">
      <h1 className="font-display text-4xl md:text-5xl tracking-tighter font-light mb-8">{lang === "nl" ? "Categorieën" : "Categories"}</h1>

      <div className="border border-black/10 bg-white p-6 mb-6">
        <div className="font-label text-ink-muted mb-3">{lang === "nl" ? "Nieuwe categorie" : "New category"}</div>
        <div className="grid grid-cols-4 gap-3">
          <input value={newCat.slug} onChange={(e) => setNewCat({ ...newCat, slug: e.target.value })} placeholder="slug" className="border border-black/15 px-3 py-2 text-sm" data-testid="category-new-slug" />
          <input value={newCat.name_en} onChange={(e) => setNewCat({ ...newCat, name_en: e.target.value })} placeholder="Name (EN)" className="border border-black/15 px-3 py-2 text-sm" data-testid="category-new-name-en" />
          <input value={newCat.name_nl} onChange={(e) => setNewCat({ ...newCat, name_nl: e.target.value })} placeholder="Naam (NL)" className="border border-black/15 px-3 py-2 text-sm" data-testid="category-new-name-nl" />
          <button onClick={create} className="btn-primary text-sm" data-testid="category-create"><Plus className="w-4 h-4" /> {lang === "nl" ? "Toevoegen" : "Add"}</button>
        </div>
      </div>

      <div className="border border-black/10 bg-white divide-y divide-black/5">
        {items.map((c, i) => (
          <div key={c.slug} className="p-4 grid grid-cols-12 gap-3 items-center" data-testid={`category-row-${c.slug}`}>
            <div className="col-span-2 font-mono text-xs">{c.slug}</div>
            <input value={c.name_en} onChange={(e) => update(i, "name_en", e.target.value)} className="col-span-3 border border-black/15 px-2 py-1.5 text-sm" />
            <input value={c.name_nl} onChange={(e) => update(i, "name_nl", e.target.value)} className="col-span-3 border border-black/15 px-2 py-1.5 text-sm" />
            <input type="number" value={c.order || 0} onChange={(e) => update(i, "order", parseInt(e.target.value) || 0)} className="col-span-1 border border-black/15 px-2 py-1.5 text-sm" />
            <div className="col-span-3 flex justify-end gap-1">
              <button onClick={() => save(c)} className="p-2 hover:bg-secondary-warm"><Save className="w-4 h-4" /></button>
              <button onClick={() => remove(c.slug)} className="p-2 hover:bg-terracotta/10 text-terracotta"><Trash2 className="w-4 h-4" /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminCategories;
